import React from 'react';

export default function Camera({ width = '16', height = '13', viewBox = `0 0 ${width} ${height}`, color = 'white' }) {
  return (
    <svg width={width} height={height} viewBox={viewBox} fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.2541 1.18182H14C15.1046 1.18182 16 2.07725 16 3.18182V11C16 12.1046 15.1046 13 14 13H2C0.895431 13 0 12.1046 0 11V3.18182C0 2.07725 0.895431 1.18182 2 1.18182H4.7459C5.0586 0.485182 5.75835 0 6.57143 0H9.42857C10.2416 0 10.9414 0.485182 11.2541 1.18182ZM11.4286 7.09091C11.4286 9.04901 9.89355 10.6364 8 10.6364C6.10645 10.6364 4.57143 9.04901 4.57143 7.09091C4.57143 5.13281 6.10645 3.54545 8 3.54545C9.89355 3.54545 11.4286 5.13281 11.4286 7.09091ZM12 4.72727C12.3156 4.72727 12.5714 4.46271 12.5714 4.13636C12.5714 3.81001 12.3156 3.54545 12 3.54545C11.6844 3.54545 11.4286 3.81001 11.4286 4.13636C11.4286 4.46271 11.6844 4.72727 12 4.72727Z"
        fill={color}
      />
    </svg>
  );
}
